import type { IServiceJourneyCoordinate } from '../../../models/service-journey-coordinate.model';

export class CoordinateApiModel {
  public static mapToBusinessModel(apiModel: CoordinateApiModel): IServiceJourneyCoordinate {
    return {
      isOnTripLeg: apiModel.isOnTripLeg,
      isTripLegStart: apiModel.isTripLegStart,
      isTripLegStop: apiModel.isTripLegStart,
      latitude: apiModel.latitude,
      longitude: apiModel.longitude,
    };
  }

  public latitude!: number;
  public longitude!: number;
  public elevation?: number;
  public isTripLegStop?: boolean;
  public isTripLegStart?: boolean;
  public isOnTripLeg?: boolean;
}
